/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { MenuHoursGroup } from '../../models/menu-hours-group';
import { MenuHoursGroupInput } from '../../models/menu-hours-group-input';

export interface MenuHoursGroupPost$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
      body: MenuHoursGroupInput
}

export function menuHoursGroupPost(http: HttpClient, rootUrl: string, params: MenuHoursGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & MenuHoursGroup & {

/**
 * Indicates whether this group should be treated as the menu's brand-level hours group.
 */
'isBrandMenuHours'?: boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & MenuHoursGroup & {
      
      /**
       * Indicates whether this group should be treated as the menu's brand-level hours group.
       */
      'isBrandMenuHours'?: boolean;
      }>;
    })
  );
}

menuHoursGroupPost.PATH = '/menus/{menuId}/hours';
